export const REFINED_PRODUCT_ID = "6ac25ecc832b0ae9e0b1abfc";
export const REFINED_STOREFRONT_URL = "https://refined.errorism.co/";

export function isRefinedStorefrontProduct(product: { id: string } | undefined): boolean {
	return product?.id === REFINED_PRODUCT_ID;
}

export function storefrontPriceLabel(product: { id: string; price: number }): string {
	if (isRefinedStorefrontProduct(product)) return "Contact";
	return product.price <= 0 ? "ฟรี" : `${product.price.toLocaleString()} THB`;
}
